const YEAR_INPUT_REGEX = /^\d*$/
const YEAR_VALUE_REGEX = /^\d{1,4}$/

export const isValidYearInput = (value: string): boolean =>
  YEAR_INPUT_REGEX.test(value)

export const getYearValidationError = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return ""
  if (!YEAR_VALUE_REGEX.test(trimmed)) {
    return "Year must be a numeric value."
  }
  return ""
}

export const normalizeYearInput = (value: string): string =>
  value.replace(/\D/g, "").slice(0, 4)

export const parseYearOrNull = (value: string): number | null => {
  const trimmed = value.trim()
  if (!trimmed) return null
  if (getYearValidationError(trimmed)) return null
  return Number(trimmed)
}
